import * as React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

const URL1 = 'https://www.msamlin.com/en/site-services/data-privacy-notice' +
  '/avis-de-la-protection-des-donnees-des-clients.html';

class UsefulLinks extends React.Component {

  public render() {
    return (
      <div className="container content-page">
        <Row>
          <Col sm={12}>
            <h2>Lien utiles</h2>
            <p>N'hésitez pas à consulter les sites suivants pour en savoir plus :</p>

            <h3>Les sites institutionnels :</h3>
            <ul>
              <li>
                <a target={'_blank'} href="https://www.orias.fr/">ORIAS</a>
              </li>
              <li>
                <a target={'_blank'} href="https://acpr.banque-france.fr/">ACPR</a>
              </li>
              <li>
                <a target={'_blank'} href="https://www.ffa-assurance.fr/">FFA</a>
              </li>
              <li>
                <a target={'_blank'} href="https://www.cnil.fr/professionnel">CNIL</a>
              </li>
            </ul>

            <h3>Les sites juridiques :</h3>
            <ul>
              <li>
                <a target={'_blank'} href="https://www.legifrance.gouv.fr/">Légifrance</a>
              </li>
              <li>
                <a target={'_blank'} href="http://www.assemblee-nationale.fr/">Assemblée nationale</a>
              </li>
              <li>
                <a target={'_blank'} href="http://www.senat.fr/">Sénat</a>
              </li>
              <li>
                <a target={'_blank'} href="https://eur-lex.europa.eu/homepage.html">Droit de l'Union Européenne</a>
              </li>
            </ul>

            <h3>En savoir plus sur MS Amlin :</h3>
            <ul>
              <li>
                <a target={'_blank'} href="https://www.msamlin.com/en/markets/France.html">MS Amlin en France</a>
              </li>
              <li>
                <a target={'_blank'} href={URL1}>Politique de confidentialité</a>
              </li>
              <li>
                <a target={'_blank'}
                   href="https://www.msamlin.com/en/markets/France/Partenariat/R%C3%A9clamations.html"
                >
                  Procédure de réclamation
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(UsefulLinks);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Brochure/scenes/UsefulLinks/index.tsx